var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewJewelry6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "new_x5F_jewelry"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32___x5B_rejected_x5D_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#202228",
    d: "M348,493.9c-0.8,1.4-1.4,2.2-1.1,3.8c0.4,1.9,2.1,2,3.7,2.1c-0.1,4.4,3.2,5.6,6.1,4.3 c0.3,3,3.8,3.2,5.4,2.9c1.6-0.3,2.5-1.2,3.1-3c2.6,1.7,7.1-0.2,6.5-3.9c1.6,0.2,3.1-1.1,3.3-2.6c0.3-2-1.7-4-3.6-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#353C42",
    d: "M356.6,484.8c-2.7,2.3-5.1,5-7.5,7.7c-0.8,0.9-1.9,2-1.7,3.3c0.3,1.7,2.4,1.4,3.5,0.9 c-0.7,1.1-0.1,2.9,0.8,3.8c1.5,1.4,3.6,1.3,4.6,0c-0.5,2.3,2.5,3.7,4.5,3.4c1.6-0.2,2.9-1.3,3.4-2.9c2.1,2.3,7,1.6,6.2-3.3 c1.5,0.5,3.6-1,3.3-2.6c-0.3-1.7-2.7-2.8-4-3.6c-1.6-0.9-3.4-2.2-5-3.2c-1-0.7-1.7-1.2-2.7-1.9c-1-0.7-2.2-1.5-3.3-2.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(3.489936e-02 -0.9994 0.9994 3.489936e-02 -165.0215 709.4218)",
    fill: "#14131E",
    cx: 284.8,
    cy: 440.2,
    rx: 2.2,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40404C",
    d: "M286.6,439.6c0-0.5-0.1-0.9-0.4-1.3c-0.4-0.2-0.8-0.4-1.3-0.4c-1.4,0-2.5,0.9-2.6,2.1 c0,0.5,0.1,0.9,0.4,1.3c0.4,0.2,0.8,0.4,1.3,0.4C285.5,441.7,286.6,440.8,286.6,439.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#545661",
    d: "M283.4,440.2L283.4,440.2c-0.2,0-0.3-0.2-0.3-0.4c0.1-0.6,0.6-1.3,1.4-1.3c0.2,0,0.3,0.1,0.4,0.3 c0,0.2-0.1,0.3-0.3,0.4c-0.4,0-0.7,0.4-0.8,0.7C283.8,440.1,283.6,440.2,283.4,440.2L283.4,440.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F5D6B1",
    d: "M295.8,450.8c4,6,4.8,12.3,2.6,13.6c-2,1.2-7.8-1.6-11.8-7.6s-4.6-12.1-2.6-13.9 C285.8,441.5,291.9,444.8,295.8,450.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M295.2,449.9c-0.2-0.3-0.5-0.6-0.7-0.9c-3.4,0.7-5.7,5.2-9.1,5.7c0.2,0.5,0.5,0.9,0.8,1.4 c2.2-0.1,4-0.4,5.7-2.1C293.1,452.8,293.2,450,295.2,449.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M287.8,449.4c0.8-1.4,2.8-3.3,4.6-2.8c-0.4-0.3-0.7-0.7-1.1-1c-1.4,0.7-3.1,1.5-4.2,2.5 c-1,0.8-1.7,3-3,3.7c0.1,0.1,0.1,0.3,0.2,0.4C285.8,452,286.9,451,287.8,449.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M285.5,445.9c0.8-0.6,1.5-1.9,2.3-2.6c-0.3-0.2-0.6-0.3-0.9-0.4c-0.9,1.3-2.3,3-4,3.6 c0,0.4,0.1,0.9,0.1,1.4C283.7,447.2,284.7,446.5,285.5,445.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M296.4,461.4c-0.6,0.7-1.2,1.7-1.5,2.7c0.3,0.1,0.7,0.2,1,0.3c0.5-1.6,2.2-3.5,3.7-3.9 c0-0.3-0.1-0.6-0.1-1C298.4,460,297.4,460.4,296.4,461.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M295.3,460.9c0.7-1,0.4-2.1,1.1-3.1c0.6-0.8,1.4-1.2,2.3-1.3c-0.1-0.3-0.2-0.6-0.3-0.9 c-1.6,0.3-3.1,2.3-4.2,3.2c-1.3,1.1-2.7,1.7-4.2,1.9c0.6,0.6,1.2,1.1,1.8,1.6C293.1,462.3,294.5,462,295.3,460.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M293,456.2c1.4-1.7,2.5-3,4.5-2.5c-0.2-0.4-0.5-0.9-0.7-1.3c-1.9-0.3-3.3,2.3-4.5,3.4 c-1.1,1-3.3,2-5.1,1.9c0.3,0.4,0.6,0.8,1,1.2C290.1,458.8,291.8,457.7,293,456.2z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.6,442.7c-0.2,0.1-0.3,0.1-0.5,0.2c-2,1.7-1.4,7.9,2.6,13.9s9.8,8.8,11.8,7.6l0.1-0.1 C290.5,461.5,284.7,451.8,284.6,442.7z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M298.7,462.9c-0.6-4.3-1.6-8.2-4.3-12c-2.4-3.2-5.3-5.2-8.6-7.1c3.2,2.1,5.3,4.8,7.5,7.9 C295.8,455.2,297.9,458.5,298.7,462.9L298.7,462.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F5D6B1",
    d: "M315.8,468.7c6.3,3.4,10.1,8.4,8.8,10.7c-1.1,2-7.6,2.4-13.9-1s-9.9-8.4-8.9-10.9 C302.5,465.4,309.4,465.4,315.8,468.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M314.8,468.3c-0.4-0.2-0.7-0.3-1.1-0.5c-2.6,2.3-2.5,7.3-5.3,9.4c0.4,0.3,0.9,0.6,1.3,0.8 c1.9-1.1,3.3-2.3,4-4.6C314.4,471.7,313.1,469.3,314.8,468.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M308,471.4c0-1.6,0.9-4.3,2.6-4.7c-0.5-0.1-1-0.2-1.4-0.3c-0.9,1.3-2,2.8-2.5,4.2 c-0.4,1.2-0.1,3.4-0.8,4.6c0.1,0.1,0.2,0.2,0.4,0.3C307.6,474.6,308,473.2,308,471.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M304.4,469.4c0.4-0.9,0.4-2.4,0.8-3.4c-0.4,0-0.7,0-1,0.1c-0.1,1.6-0.6,3.7-1.7,5.1 c0.2,0.4,0.5,0.8,0.8,1.2C303.4,471.4,303.9,470.4,304.4,469.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M321.4,477.7c-0.2,0.9-0.3,2.1,0,3.1c0.4,0,0.7-0.1,1-0.2c-0.3-1.6,0.3-4.1,1.4-5.2 c-0.2-0.3-0.4-0.5-0.6-0.8C322.4,475.6,321.7,476.4,321.4,477.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M320.1,477.9c0.1-1.2-0.7-2.1-0.5-3.3c0.1-1,0.6-1.7,1.4-2.2c-0.2-0.2-0.5-0.4-0.7-0.6 c-1.3,1.1-1.6,3.5-2.2,4.9c-0.6,1.6-1.5,2.7-2.8,3.7c0.8,0.2,1.6,0.4,2.3,0.5C318.9,480.1,320,479.2,320.1,477.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M315.9,474.8c0.4-2.2,0.7-3.8,2.7-4.3c-0.4-0.3-0.8-0.6-1.2-0.8c-1.8,0.7-1.8,3.6-2.3,5.2 c-0.5,1.4-1.9,3.4-3.5,4.1c0.5,0.2,1,0.4,1.4,0.6C314.6,478.5,315.6,476.6,315.9,474.8z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302,467.1c-0.1,0.1-0.2,0.3-0.3,0.4c-1,2.5,2.6,7.6,8.9,10.9c6.3,3.4,12.8,3,13.9,1v-0.1 C316.3,480.6,306.5,475,302,467.1z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M324.1,478c-2.6-3.5-5.3-6.5-9.5-8.5c-3.7-1.7-7.1-2-10.9-2.1c3.9,0.3,7,1.7,10.4,3.3 C317.9,472.6,321.3,474.5,324.1,478L324.1,478z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F5D6B1",
    d: "M342.3,477c7.1,1,12.3,4.6,11.9,7.1c-0.4,2.3-6.4,4.8-13.5,3.8s-12.1-4.6-12.1-7.3 C328.7,478.3,335.2,476,342.3,477z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M341.2,476.9c-0.4,0-0.8-0.1-1.1-0.1c-1.7,3,0.1,7.7-1.8,10.6c0.5,0.1,1,0.2,1.5,0.3 c1.4-1.7,2.4-3.2,2.2-5.7C341.9,480.3,339.9,478.4,341.2,476.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M335.9,482.1c-0.5-1.5-0.6-4.3,0.9-5.3c-0.5,0-1,0.1-1.4,0.2c-0.4,1.5-0.9,3.3-1,4.8 c0,1.3,1.1,3.2,0.8,4.6c0.1,0.1,0.3,0.1,0.4,0.2C336.5,485.3,336.5,483.9,335.9,482.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M331.8,481.5c0.1-1-0.4-2.4-0.4-3.4c-0.3,0.1-0.6,0.3-0.9,0.4c0.4,1.6,0.7,3.7,0.1,5.3 c0.3,0.3,0.7,0.6,1.1,0.9C331.5,483.7,331.6,482.5,331.8,481.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M350.6,483.6c0.1,0.9,0.5,2.1,1,3c0.3-0.2,0.6-0.3,0.9-0.5c-0.8-1.4-1.1-3.9-0.5-5.4 c-0.2-0.2-0.5-0.4-0.8-0.6C350.8,481.3,350.4,482.2,350.6,483.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M349.4,484.2c-0.3-1.1-1.3-1.7-1.6-2.9c-0.2-1,0-1.9,0.5-2.6c-0.3-0.1-0.6-0.2-0.9-0.3 c-0.8,1.4-0.3,3.8-0.4,5.3c-0.1,1.7-0.5,3.1-1.4,4.4c0.8-0.1,1.6-0.2,2.4-0.3C349.1,486.7,349.8,485.4,349.4,484.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M344.4,482.7c-0.4-2.2-0.6-3.9,1.1-5c-0.5-0.1-1-0.2-1.5-0.4c-1.5,1.2-0.5,4-0.4,5.6 c0,1.5-0.7,3.8-1.9,5c0.5,0.1,1.1,0.1,1.6,0.1C344.4,486.6,344.7,484.6,344.4,482.7z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.7,480.1c-0.1,0.2-0.1,0.3-0.1,0.5c-0.1,2.7,5,6.3,12.1,7.3s13.1-1.5,13.5-3.8V484 C346.7,488.1,335.6,486,328.7,480.1z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M353.2,483c-3.7-2.4-7.2-4.3-11.8-4.8c-4-0.4-7.4,0.5-11,1.7c3.7-1,7.1-0.8,10.9-0.4 C345.5,480,349.4,480.6,353.2,483L353.2,483z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F5D6B1",
    d: "M374.4,476.8c7.1-0.7,13.1,1.4,13.3,4c0.2,2.3-5,6.2-12.1,6.9c-7.1,0.7-12.9-1.5-13.5-4.2 C361.5,481.4,367.2,477.5,374.4,476.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M373.3,476.9c-0.4,0.1-0.8,0.1-1.1,0.2c-0.9,3.4,2,7.4,0.8,10.7c0.5,0,1,0,1.6-0.1c1-2,1.5-3.7,0.8-6.1 C374.9,480.1,372.4,478.7,373.3,476.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M369.4,483.3c-0.9-1.3-1.7-4-0.4-5.3c-0.5,0.2-0.9,0.3-1.4,0.5c0,1.6-0.1,3.4,0.2,4.9 c0.3,1.2,1.8,2.9,1.9,4.3c0.2,0,0.3,0,0.5,0.1C370.8,486.2,370.4,484.8,369.4,483.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M365.3,483.7c-0.1-1-1-2.2-1.2-3.3c-0.3,0.2-0.5,0.4-0.8,0.6c0.8,1.4,1.5,3.4,1.4,5.2 c0.4,0.2,0.8,0.4,1.3,0.5C365.5,485.9,365.4,484.7,365.3,483.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M384,481.2c0.3,0.9,1,1.9,1.7,2.6c0.3-0.2,0.5-0.5,0.7-0.7c-1.2-1.1-2-3.5-1.7-5.1 c-0.3-0.1-0.6-0.2-0.9-0.3C383.7,478.8,383.5,479.9,384,481.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M383.1,482c-0.6-1-1.7-1.4-2.2-2.4c-0.4-0.9-0.4-1.8-0.1-2.6c-0.3,0-0.6-0.1-1-0.1 c-0.5,1.6,0.6,3.8,0.9,5.3c0.4,1.7,0.2,3.1-0.3,4.6c0.8-0.3,1.5-0.6,2.2-0.9C383.3,484.6,383.7,483.1,383.1,482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M377.8,481.8c-0.9-2-1.5-3.6-0.1-5.1c-0.5,0-1,0-1.5,0c-1.1,1.5,0.5,4,1,5.5c0.4,1.4,0.3,3.9-0.6,5.4 c0.5-0.1,1-0.2,1.5-0.3C378.8,485.6,378.6,483.5,377.8,481.8z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362,483c0,0.2,0,0.4,0,0.5c0.6,2.6,6.3,4.9,13.5,4.2c7.1-0.7,12.3-4.6,12.1-6.9v-0.1C381.4,486.4,370.1,487.2,362,483z "
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M386.4,479.9c-4.1-1.5-8-2.4-12.6-1.8c-4,0.6-7.1,2.3-10.3,4.3c3.4-1.9,6.7-2.5,10.5-3 C378.3,478.9,382.2,478.6,386.4,479.9L386.4,479.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F5D6B1",
    d: "M401.6,469.8c6.7-2.7,13-2.2,13.8,0.2c0.8,2.2-3.1,7.3-9.8,10c-6.7,2.7-12.8,2.1-14.1-0.3 C390.5,477.7,395,472.4,401.6,469.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M400.6,470.2c-0.4,0.2-0.7,0.3-1,0.5c0,3.5,3.9,6.6,3.7,10.1c0.5-0.1,1-0.3,1.5-0.5c0.4-2.2,0.4-4-0.9-6 C403,472.8,400.3,472.1,400.6,470.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M398.7,477.4c-1.2-1-2.7-3.4-1.9-5c-0.4,0.3-0.8,0.6-1.2,0.9c0.4,1.5,0.8,3.3,1.6,4.6 c0.6,1.1,2.6,2.3,3,3.6c0.2,0,0.3,0,0.5-0.1C400.8,479.8,400,478.6,398.7,477.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M394.8,478.9c-0.4-0.9-1.6-1.8-2-2.8c-0.2,0.3-0.4,0.6-0.6,0.8c1.1,1.1,2.4,2.9,2.7,4.6 c0.4,0.1,0.9,0.1,1.4,0.2C395.6,480.9,395.2,479.8,394.8,478.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M412.1,471.3c0.6,0.7,1.4,1.6,2.4,2c0.2-0.3,0.4-0.6,0.5-0.9c-1.4-0.8-2.9-2.8-3.1-4.4 c-0.3,0-0.6-0.1-1-0.1C411.1,469.1,411.3,470.2,412.1,471.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M411.4,472.3c-0.8-0.8-2-0.8-2.8-1.7c-0.7-0.7-0.9-1.6-0.8-2.5c-0.3,0-0.6,0.1-0.9,0.1 c0,1.7,1.6,3.5,2.3,4.8c0.8,1.5,1.1,2.9,1,4.5c0.7-0.5,1.3-1,1.9-1.5C412.4,474.7,412.3,473.3,411.4,472.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M406.3,473.6c-1.4-1.7-2.4-3.1-1.5-4.9c-0.5,0.1-1,0.3-1.4,0.4c-0.6,1.8,1.6,3.7,2.5,5.1 c0.8,1.3,1.3,3.7,0.9,5.3c0.5-0.2,1-0.5,1.4-0.7C408.3,477,407.5,475,406.3,473.6z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.4,479.2c0,0.2,0.1,0.4,0.1,0.5c1.3,2.4,7.4,2.9,14.1,0.3c6.7-2.7,10.6-7.8,9.8-10c0,0,0-0.1-0.1-0.1 C411,477.1,400.4,480.9,391.4,479.2z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M414,469.4c-4.4-0.3-8.4-0.1-12.6,1.8c-3.7,1.7-6.2,4.1-8.7,7c2.7-2.8,5.8-4.2,9.2-5.8 C405.9,470.7,409.6,469.3,414,469.4L414,469.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F5D6B1",
    d: "M421.3,453.1c4.5-5.6,10.3-8.2,12.2-6.5c1.8,1.5,0.8,7.9-3.7,13.5c-4.6,5.6-10.2,8-12.5,6.6 C415.3,465.4,416.7,458.7,421.3,453.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M420.6,454c-0.2,0.3-0.5,0.6-0.7,0.9c1.7,3,6.6,3.9,8.1,7c0.4-0.4,0.7-0.8,1.1-1.2 c-0.7-2.1-1.6-3.7-3.7-4.9C423.9,455.1,421.2,455.9,420.6,454z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M422.3,461.2c-1.5-0.3-4-1.7-4.1-3.5c-0.2,0.4-0.4,0.9-0.6,1.3c1.1,1.1,2.3,2.5,3.6,3.3 c1.1,0.7,3.3,0.8,4.4,1.7c0.1-0.1,0.2-0.2,0.4-0.3C425.4,462.3,424.1,461.6,422.3,461.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M419.7,464.4c-0.8-0.6-2.3-0.8-3.1-1.5c-0.1,0.3-0.1,0.7-0.1,1c1.5,0.4,3.5,1.3,4.6,2.7 c0.4-0.1,0.9-0.3,1.3-0.5C421.4,465.8,420.5,465.1,419.7,464.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M431.2,449.4c0.8,0.4,2,0.7,3.1,0.6c0-0.4,0-0.7,0-1c-1.6,0-3.9-1.1-4.8-2.4c-0.3,0.1-0.6,0.2-0.9,0.4 C429.3,448,429.9,448.8,431.2,449.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M431.1,450.7c-1.1-0.3-2.2,0.2-3.3-0.1c-0.9-0.3-1.6-1-1.9-1.8c-0.3,0.2-0.5,0.4-0.8,0.6 c0.8,1.5,3.1,2.3,4.4,3.1c1.4,0.9,2.4,2.1,3,3.5c0.4-0.8,0.7-1.5,0.9-2.2C433.1,452.3,432.3,451,431.1,450.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CD9A88",
    d: "M427.2,454.2c-2.1-0.8-3.6-1.5-3.7-3.5c-0.4,0.3-0.7,0.7-1.1,1.1c0.3,1.9,3.2,2.4,4.6,3.2 c1.3,0.7,2.9,2.6,3.3,4.3c0.3-0.4,0.6-0.9,0.9-1.3C430.6,456.2,429,454.9,427.2,454.2z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.9,466.3c0.1,0.2,0.2,0.3,0.4,0.4c2.3,1.4,7.9-1,12.5-6.6s5.5-11.9,3.7-13.5c0,0-0.1,0-0.1-0.1 C433,455,425.5,463.5,416.9,466.3z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M432,446.8c-4,1.9-7.4,3.9-10.2,7.6c-2.4,3.2-3.4,6.6-4.2,10.3c1-3.7,3-6.5,5.3-9.5 C425.5,451.8,428,448.9,432,446.8L432,446.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#14131E",
    cx: 300.2,
    cy: 466.1,
    rx: 2.2,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40404C",
    d: "M301.8,465.6c0-0.5-0.1-0.9-0.3-1.3c-0.3-0.2-0.7-0.4-1.2-0.4c-1.2,0-2.2,0.9-2.2,2.1 c0,0.5,0.1,0.9,0.3,1.3c0.3,0.2,0.7,0.4,1.2,0.4C300.7,467.7,301.7,466.8,301.8,465.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#545661",
    d: "M299,466.2L299,466.2c-0.2,0-0.3-0.2-0.3-0.4c0.1-0.6,0.5-1.3,1.2-1.3c0.2,0,0.3,0.1,0.3,0.3 c0,0.2-0.1,0.3-0.3,0.4c-0.4,0-0.6,0.4-0.7,0.7C299.3,466.1,299.1,466.2,299,466.2L299,466.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#14131E",
    cx: 326.9,
    cy: 479.4,
    rx: 2.7,
    ry: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40404C",
    d: "M328.8,478.8c0-0.6-0.1-1.1-0.4-1.5c-0.4-0.3-0.9-0.5-1.4-0.5c-1.5-0.1-2.7,1.1-2.8,2.6 c0,0.6,0.1,1.1,0.4,1.6c0.4,0.3,0.9,0.5,1.4,0.5C327.5,481.5,328.7,480.3,328.8,478.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#545661",
    d: "M325.3,479.6L325.3,479.6c-0.2,0-0.4-0.2-0.3-0.5c0.1-0.7,0.7-1.6,1.5-1.6c0.2,0,0.4,0.2,0.4,0.4 c0,0.2-0.1,0.4-0.3,0.4c-0.5,0-0.8,0.5-0.8,0.9C325.7,479.4,325.5,479.6,325.3,479.6L325.3,479.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#14131E",
    cx: 390,
    cy: 480,
    rx: 2.5,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40404C",
    d: "M391.8,479.4c0-0.5-0.1-1-0.4-1.5c-0.4-0.3-0.8-0.4-1.3-0.4c-1.4,0-2.6,1-2.6,2.4c0,0.5,0.1,1,0.4,1.5 c0.4,0.3,0.8,0.4,1.3,0.4C390.6,481.9,391.8,480.8,391.8,479.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#545661",
    d: "M388.5,480.1L388.5,480.1c-0.2,0-0.4-0.2-0.3-0.4c0.1-0.7,0.6-1.5,1.4-1.5c0.2,0,0.3,0.1,0.4,0.4 c0,0.2-0.1,0.4-0.3,0.4c-0.4,0-0.7,0.5-0.8,0.9C388.9,479.9,388.7,480.1,388.5,480.1L388.5,480.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#14131E",
    cx: 416.9,
    cy: 468.1,
    rx: 2.2,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40404C",
    d: "M418.5,467.6c0-0.5-0.1-0.9-0.3-1.3c-0.3-0.2-0.7-0.4-1.2-0.4c-1.2,0-2.2,0.9-2.2,2.1 c0,0.5,0.1,0.9,0.3,1.3c0.3,0.2,0.7,0.4,1.2,0.4C417.4,469.7,418.4,468.8,418.5,467.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#545661",
    d: "M415.7,468.2C415.7,468.2,415.6,468.2,415.7,468.2c-0.2,0-0.3-0.2-0.3-0.4c0.1-0.6,0.5-1.3,1.2-1.3 c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.4c-0.4,0-0.6,0.4-0.7,0.7C415.9,468.1,415.8,468.2,415.7,468.2L415.7,468.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#14131E",
    cx: 433.5,
    cy: 444.2,
    rx: 2.2,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40404C",
    d: "M435.1,443.6c0-0.5-0.1-0.9-0.3-1.3c-0.3-0.2-0.7-0.4-1.2-0.4c-1.2,0-2.2,0.9-2.2,2.1 c0,0.5,0.1,0.9,0.3,1.3c0.3,0.2,0.7,0.4,1.2,0.4C434.1,445.7,435.1,444.8,435.1,443.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#545661",
    d: "M432.3,444.2L432.3,444.2c-0.2,0-0.3-0.2-0.3-0.4c0.1-0.6,0.5-1.3,1.2-1.3c0.2,0,0.3,0.1,0.3,0.3 c0,0.2-0.1,0.3-0.3,0.4c-0.4,0-0.6,0.4-0.7,0.7C432.6,444.1,432.5,444.2,432.3,444.2L432.3,444.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#14131E",
    cx: 358,
    cy: 483.5,
    rx: 3.6,
    ry: 3.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#40404C",
    d: "M360.6,482.6c0-0.8-0.2-1.5-0.6-2.1c-0.5-0.4-1.2-0.6-1.9-0.6c-2-0.1-3.7,1.5-3.7,3.5 c0,0.8,0.2,1.5,0.6,2.1c0.5,0.4,1.2,0.6,1.9,0.6C358.9,486.2,360.6,484.6,360.6,482.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#545661",
    d: "M356,483.6C356,483.6,355.9,483.6,356,483.6c-0.3-0.1-0.5-0.3-0.5-0.6c0.1-1,0.9-2.1,2.1-2.2 c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.6-0.5,0.6c-0.6,0-1.1,0.7-1.1,1.2C356.4,483.4,356.2,483.6,356,483.6L356,483.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#535860",
    d: "M354.8,488.2c-1.2,1-2.7,2.4-3.8,3.8c-0.6,0.7-1.4,1.3-1.7,2.1c-0.5,1.4,0.3,1.6,1,0.5 C351.8,492.4,353.2,490.1,354.8,488.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535860",
    d: "M362.5,488.1c1.2,1.6,2.9,3.5,4.6,5c0.8,0.8,1.6,1.8,2.5,2.3c1.6,0.8,1.8,0,0.5-1 C367.6,492.4,364.8,490.4,362.5,488.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535860",
    d: "M356,489.1c-1,1.7-1.9,3.8-2.8,5.6c-0.6,1.3-2.3,4.2-0.4,5.2c0.3,0.2,0.9,0.1,1.2,0 c-3.4-0.5,1.3-8.6,1.8-10.1C355.9,489.5,355.9,489.5,356,489.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535860",
    d: "M357.5,487.9c0,2.8-0.1,5.6-0.1,8.2c0,1.9-0.4,6.6,2.4,6.7c0.5,0,1.2-0.3,1.5-0.7 c-4.4,2.2-3.2-10.3-3.5-12.4C357.7,489.5,357.6,488.4,357.5,487.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535860",
    d: "M359.7,487.7c1.1,2.6,2.2,5.2,3.2,7.5c0.8,1.7,2.4,6.1,5,5.1c0.5-0.2,0.9-0.8,1.1-1.2 c-3.1,3.8-7.1-8.1-8.2-9.8C360.5,489.1,360,488.1,359.7,487.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJewelry6);
export default __webpack_public_path__ + "static/media/new_jewelry_6.8fb3a6d78b6bb068c7a0b38535819598.svg";
export { ForwardRef as ReactComponent };